import aT from '../const/action-type'
import initial from '../store/initial'
//
export default (state = initial.industries, action) => {
  switch (action.type) {
    case aT.SET_INDUSTRIES:
      return [...action.data]
    case aT.RESET_STORE:
      return initial.industries
    case aT.SWITCH_WORKSPACE:
      return initial.industries
    default:
      return state
  }
}
